<div class="map-container">
    <div #mapPanel class="mapPanel"></div>
  
    <button pButton type="button" icon="pi pi-comments" class="comments-button" (click)="onAIChat()"></button>
  </div>
  <div class="content-container">
    <div class="filter-container">
      <h2 style="align-items: flex-end;">
        <div style="background-color: var(--primary-500); display: flex; border-radius: 7px; width: 27px; height: 30px;">
          <img [src]="mainIcon" alt="mainIcon" style="filter: brightness(0) invert(1); object-fit: cover;">
        </div>Filter
      </h2>
      <p>Name</p>
      <input [(ngModel)]="filterName" type="text" pInputText placeholder="Enter Name">
      <p>Price</p>
      <div class="budget-slider">
        <p-slider [(ngModel)]="budget" [range]="true" [min]="0" [max]="2000000" [style]="{'width':'100%'}" (onChange)="onSliderChange($event)"></p-slider>
        <div class="budget-inputs">
          <p>Min :</p>
          <p-inputNumber [(ngModel)]="budget[0]" mode="currency" currency="THB" [min]="0" [max]="2000000" (onInput)="onMinChange($event)"></p-inputNumber>
          <p>Max :</p>
          <p-inputNumber [(ngModel)]="budget[1]" mode="currency" currency="THB" [min]="0" [max]="2000000" (onInput)="onMaxChange($event)"></p-inputNumber>
        </div>
      </div>
      <p>Bedroom Total</p>
      <input [(ngModel)]="filterBedroom" min="0" type="number" pInputText>
      <p>Bathroom Total</p>
      <input [(ngModel)]="filterBathroom" min="0" type="number" pInputText>
      <div class="button-container">
        <p-button label="Clear" (onClick)="onClearClick()" [outlined]="true" styleClass="clearBtn"></p-button>
        <p-button label="Sumit" (onClick)="onApplyClick()"></p-button>
      </div>
    </div>
    <div class="result-container">
      <div class="top-section">
        <p>ผลลัพธ์ {{ requestList.length }} รายการ</p>
      </div>
      <p-table [value]="requestList" [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template pTemplate="header">
          <tr>
            <th>Project</th>
            <th>Location</th>
            <th>Description</th>
            <th>Room Size (Sq.m)</th>
            <th>Bedroom</th>
            <th>Bathroom</th>
            <th>Cost(THB)</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
            <tr>
              <td>
                <!--Prooject--->
                <p>{{rowData.Project}}</p>
              </td>
              <td>
                {{rowData.Location}}
              </td>
              <td>
                {{rowData.Description}}
              </td>
              <td>
                {{rowData.RoomSize}}
              </td>
              <td>
                {{rowData.Bedroom}}
              </td>
              <td>
                {{rowData.Bathroom}}
              </td>
              <td>
                {{rowData.Cost}}
              </td>

              <!-- <td> -->
                <!-- SourceUrl -->
                <!-- <a [href]="rowData.SourceUrl || 'https://atlasx.cdg.co.th/ml-search/home'" target="_blank"> -->
                  <!-- {{ rowData.SourceUrl ? 'Go to Source' : 'More' }} -->
                <!-- </a> -->
              <!-- </td> -->
              
            </tr>
          </ng-template>
      </p-table>
      <div class="bottom-section">
        <p-dropdown [(ngModel)]="pageSize" [options]="pageSizeList" (onChange)="onPageSizeChange($event)"></p-dropdown>
        <p>{{ getRequestBegin() + 1 }} ถึง {{ getRequestEnd() }} จาก {{ totalPage }} รายการ</p>
        <div class="button-container">
          <button (click)="onToBeginningClick()"><img [src]="toBeginningIcon" alt="beginning"></button>
          <button (click)="onBackClick()"><img [src]="backIcon" alt="back"></button>
          <button class="pageBtn" *ngFor="let i of [4, 3, 2, 1]" (click)="goto(currentPage - i)" [ngClass]="{'hidden': !isActiveButton(currentPage - i)}">{{ currentPage - i }}</button>
          <button (click)="onPageNumberClick()" class="currentBtn">{{ currentPage }}</button>
          <button class="pageBtn" *ngFor="let i of [1, 2, 3, 4]" (click)="goto(currentPage + i)" [ngClass]="{'hidden': !isActiveButton(currentPage + i)}">{{ currentPage + i }}</button>
          <button (click)="onNextClick()"><img [src]="nextIcon" alt="next"></button>
          <button (click)="onToLastClick()"><img [src]="toLastIcon" alt="last"></button>
        </div>
        <p-dialog [style]="{'width': 'fit-content', 'height': 'fit-contenet'}" [(visible)]="goto_dialog_visible" [modal]="true" [draggable]="false" [resizable]="false">
          <div class="dialog-container">
            Goto: <p-dropdown [(ngModel)]="gotoPage" [options]="getGotoOptions()" appendTo="body"></p-dropdown>
            <button (click)="onGotoClick()">Go</button>
          </div>
        </p-dialog>
      </div>
    </div>
    <p-toast></p-toast>
  </div>
  
  <div *ngIf="showChatPopup" class="chat-popup">
  <div class="chat-header">
    <h3>AI Chat <img src="assets/navbar-component-images/ai-chat.svg" alt="chat-icon"></h3>
    <button (click)="closeChatPopup()">
      <i class="pi pi-times"></i>
    </button>
  </div>
  <div class="chat-messages">
    <div *ngFor="let msg of messages" [ngClass]="{'user-message': msg.sender === 'User', 'ai-message': msg.sender === 'AI'}">
      <div class="message-content" [ngClass]="{'user-message-content': msg.sender === 'User', 'ai-message-content': msg.sender === 'AI'}">
        <img *ngIf="msg.sender === 'User'" class="avatar" src="assets/navbar-component-images/Avatar_notsignin.png" alt="Avatar">
        <div *ngIf="msg.sender === 'AI'" class="ai-avatar" >AI</div>
        <span class="message-text">{{msg.text}}</span>
      </div>
    </div>
  </div>
  <div class="chat-input">
    <input [(ngModel)]="newMessage" (keyup.enter)="sendMessage()" placeholder="Type your message...">
    <button (click)="sendMessage()">
        <i class="pi pi-send"></i>
    </button>
  </div>
</div>